(function() {
  function main() {
    const faq_entries = document.querySelectorAll('.js-faq-entry');
    for (let i = 0; i < faq_entries.length; i++) {
      const entry = faq_entries[i];

      const toggles = entry.querySelectorAll('.js-faq-toggle');
      for (let j = 0; j < toggles.length; j++) {
        const toggle = toggles[j];
        toggle.addEventListener('click', () => handleClick(entry));
      }
    }
  }

  function handleClick(element) {
    element.classList.toggle('is-open');
  }

  if (document.readyState === 'interactive' || document.readyState === 'complete') {
    main();
  } else {
    document.addEventListener('DOMContentLoaded', main);
  }
})()
